export default "__VITE_ASSET__DzTM$J7$__"